import Constants from './collections/Constants.js'

const StoreModelSchema = {
  modules: {
    Constants
  },
  actions: {
    appReady() {
      // ctx.dispatch('Constants/fetch');
    },
    /*
    |--------------------------------------------------------------------------
    | GENERAL METHODS
    |--------------------------------------------------------------------------
    */
    get(context, url) {
      let axios = window.axios.create({})
      return new Promise(resolve => {
        axios.get(url).then(
          res => {
            if (res.status === 200) {
              resolve(res.data)
            }
          },
          () => {
            resolve()
            //reject(error);
          }
        )
      })
    }
  }
}

/*
|--------------------------------------------------------------------------
| We want this model to remain vanilla at all times so we counter
| the normal node singleton by exporting it as a function.
|--------------------------------------------------------------------------
*/

const StoreModel = () => {
  return { ...StoreModelSchema }
}

export default StoreModel
export { StoreModel }
